import { SignUpHeader } from '../../components/SignUpHeader';
import { ProSignInForm } from '../../components/ProSignInForm';
import { AuthTabs } from '../../components/AuthTabs';

export default function ProSignInPage() {
  return (
    <div className="bg-white min-h-screen flex flex-col">
      <SignUpHeader mode="signup" isProfessional={true} showSwitchButton={false} />

      <main className="flex-1 flex flex-col items-center justify-center py-6 md:py-12 px-4 w-full">
        <AuthTabs mode="signin" active="professional" />
        <ProSignInForm />
      </main>
    </div>
  );
}
